var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55 7.1499L9.3125 10.9124C9.6875 11.2874 10.3 11.2874 10.675 10.9124L14.4375 7.1499L14.625 7.2999C14.95 7.5499 15.225 7.8249 15.475 8.1374L15.625 8.3249L11.8625 12.0874C11.4 12.5499 10.8 12.7999 10.2 12.8499C10.1375 12.8499 10.075 12.8499 10.0125 12.8499C9.95 12.8499 9.8875 12.8499 9.825 12.8499C9.2125 12.7999 8.625 12.5499 8.15 12.0874L4.375 8.3249L4.525 8.1374C4.775 7.8374 5.05 7.5499 5.3625 7.2999L5.55 7.1499Z",
    fill: "#FF3300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron_down.768de0c48159c50b6395bedf94c0dbeb.svg";
export { ForwardRef as ReactComponent };